<h2 mat-dialog-title> Cancelación de Procedimiento/Cirugía </h2>
<mat-dialog-content class="mat-typography">

  <mat-card>
    <mat-card-title>
      <h4>{{ procedureObject[record.procedure] }}</h4>
      <div class="datetime-div">
        <span>{{formatDate(record.interventionDatetime)}}</span>
      </div>
    </mat-card-title>

    <div>

      <span><b>Folio:</b></span>
      <p>{{ record.fileNumber }}</p>

      <span><b>Especialidad:</b></span>
      <p>{{ record.specialty? specialtyObject[record.specialty] : "-" }}</p>

      <span><b>Doctor:</b></span>
      <p>{{record.doctor? doctorObject[record.doctor] : "-"}}</p>

      <span><b>Nombre del paciente:</b></span>
      <p>{{ record.patientName }}</p>

      <span><b>Sexo del paciente:</b></span>
      <p>{{ record.patientSex }}</p>
    </div>

    <mat-card>
      <mat-card-title>Motivo de cancelación de procedimiento/cirugía</mat-card-title>
      <form [formGroup]="interventionForm">

        <mat-form-field appearance="fill" hintLabel="Seleccione la razón de la cancelación: ">
          <mat-label>Motivo</mat-label>
          <mat-select formControlName="cancel">
            @for (can of cancelOptions; track can) {
              <mat-option
                [matTooltip]="can"
                matTooltipPosition="left"
                [value]="can">{{can}}
              </mat-option>
            }
          </mat-select>
          <mat-error> Motivo es <strong>requerido</strong> </mat-error>
        </mat-form-field>

      </form>
    </mat-card>
  </mat-card>


</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Cancelar</button>
  <button mat-raised-button (click)="save()"> Guardar </button>
</mat-dialog-actions>
